import { TableCell, TableRow, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ANSWER_OPTIONS } from './constants';
import { EditableOptionCell, ResultOptionCell, UnavailableOptionCell } from './answer-option-cell';

const useStyles = makeStyles(() => ({
  questionCell: {
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
}));

export function AnswerKeyRow({ question, editing, selectedOptionId, onSelect, disabled }) {
  const classes = useStyles();
  const options = question.options ?? [];

  return (
    <TableRow>
      <TableCell className={classes.questionCell}>
        <Typography variant="body2">{question.questionNumber} - {question.shortQuestion}</Typography>
      </TableCell>
      {ANSWER_OPTIONS.map((letter, idx) => {
        const opt = options[idx];
        if (!opt) {
          return <UnavailableOptionCell key={letter} />;
        }
        if (editing) {
          return (
            <EditableOptionCell
              key={opt.id}
              checked={selectedOptionId === opt.id}
              onSelect={() => onSelect(question.questionId, opt.id)}
              disabled={disabled}
            />
          );
        }
        const chosen = question.optionSelected?.optionId === opt.id;
        return (
          <ResultOptionCell
            key={opt.id}
            chosen={chosen}
            correct={chosen && !!question.optionSelected?.isCorrect}
          />
        );
      })}
    </TableRow>
  );
}
